import React from "react";

const Box = ({ on, kid }) => (kid
  ? <span className="text-3xl">{on ? "✅" : "⬜"}</span>
  : <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded border-2 text-xs font-bold ${on ? "border-emerald-600 bg-emerald-600 text-white" : "border-slate-300 bg-white"}`}>{on ? "✓" : ""}</span>);

const Item = ({ x, on, onClick, kid, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={kid ? `flex w-full items-center gap-3 rounded-2xl p-3 text-left text-base font-semibold shadow ${on ? "bg-emerald-500 text-white" : "bg-white text-slate-700"}`
      : `flex w-full items-start gap-2 rounded-lg border p-2 text-left text-sm ${on ? "border-emerald-300 bg-emerald-50 text-slate-800" : "border-red-200 bg-red-50 text-red-800 line-through"}`}>
    <Box on={on} kid={kid} /><span>{x.text}{x.due ? <span className="ml-1 text-xs opacity-70">(due {x.due})</span> : null}</span>
  </button>
);

export const ClassDoneList = ({ items, undone, setUndone, kid }) => {
  if (!items.length) return null;
  const off = new Set(undone);
  return (
    <div className="space-y-1.5" data-testid="class-done-list">
      <p className={kid ? "text-lg font-extrabold text-slate-800" : "text-sm font-bold text-slate-800"}>Done in class today</p>
      <p className="text-xs text-slate-500">All are done. Untick only what was NOT done.</p>
      {items.map((x) => <Item key={x.id} x={x} kid={kid} on={!off.has(x.id)} testid={`class-item-${x.id}`}
        onClick={() => setUndone(off.has(x.id) ? undone.filter((i) => i !== x.id) : [...undone, x.id])} />)}
    </div>
  );
};

export const HomeworkList = ({ items, done, setDone, kid }) => {
  if (!items.length) return null;
  const on = new Set(done);
  const notDone = items.filter((x) => !on.has(x.id));
  return (
    <div className="space-y-1.5" data-testid="homework-list">
      <p className={kid ? "text-lg font-extrabold text-slate-800" : "text-sm font-bold text-slate-800"}>📝 Homework — tick what you finished</p>
      {items.map((x) => <button key={x.id} type="button" onClick={() => setDone(on.has(x.id) ? done.filter((i) => i !== x.id) : [...done, x.id])} data-testid={`hw-item-${x.id}`}
        className={kid ? `flex w-full items-center gap-3 rounded-2xl p-3 text-left text-base font-semibold shadow ${on.has(x.id) ? "bg-emerald-500 text-white" : "bg-white text-slate-700"}`
          : `flex w-full items-start gap-2 rounded-lg border p-2 text-left text-sm ${on.has(x.id) ? "border-emerald-300 bg-emerald-50" : "border-slate-200 bg-white"}`}>
        <Box on={on.has(x.id)} kid={kid} /><span>{x.text}{x.due ? <span className="ml-1 text-xs opacity-70">(due {x.due})</span> : null}</span>
      </button>)}
      {notDone.length > 0 && <div className="rounded-lg bg-amber-50 p-2 text-xs text-amber-900" data-testid="hw-not-done">
        <b>Homework not done (your teacher sees this after you press Save):</b> {notDone.map((x) => x.text).join(" · ")}</div>}
    </div>
  );
};
